import { render, staticRenderFns } from "./ProjectFilter.vue?vue&type=template&id=16cd8fd4&scoped=true"
import script from "./ProjectFilter.vue?vue&type=script&lang=js"
export * from "./ProjectFilter.vue?vue&type=script&lang=js"
import style0 from "./ProjectFilter.vue?vue&type=style&index=0&id=16cd8fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd8fd4",
  null
  
)

export default component.exports